import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { clearChunkReloadFlag } from './app/core/chunk-error-handler';

bootstrapApplication(AppComponent, appConfig)
  .then(() => clearChunkReloadFlag())
  .catch(err => console.error(err));
